export default "__VITE_ASSET__j$4TIMku__"